<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="container-fluid padding-bottom-small bottom-padding">
    <div class="col-sm-11 center-block">

        <h1 tabindex="0" aria-label="Edit Order">Edit Order</h1>

        <form [formGroup]="orderStep2Form"
              novalidate>
            <div class="row">
                <!--------------------------------
                LEFT PANEL
                --------------------------------->
                <div class="col-sm-9">

                    <!--------------------------------
                    HEADER BUTTONS
                    --------------------------------->
                    <div class="row">

                      <div class="col-sm-4">
                        <a [routerLink]="['/order-step-1/', orderRevisionId]" class="text-decoration-none">
                          <div class="card mb-5" tabindex="0" aria-label="Order Type">
                            <div class="card-header">
                              <span class="badge bg-dark text-white">1</span>&nbsp;<b class="text-dark">ORDER TYPE</b>
                            </div>
                          </div>
                        </a>
                      </div>

                      <div class="col-sm-4">
                        <div class="card mb-5" tabindex="0" aria-label="Additional Options">
                          <div class="card-header bg-primary text-white">
                            <span class="badge bg-white text-primary">2</span>&nbsp;<b>ADDITIONAL OPTIONS</b>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4 panel">
                        <a [routerLink]="['/order-step-3/', orderRevisionId]" class="text-decoration-none">
                          <div class="card mb-5" tabindex="0" aria-label="Place Order">
                            <div class="card-header">
                              <span class="badge bg-dark text-white">3</span>&nbsp;<b>PLACE ORDER</b>
                            </div>
                          </div>
                          </a>
                      </div>

                    </div>

                    <!--------------------------------
                    TRACKING NUMBER
                    --------------------------------->
                    <div class="row top-space">
                        <div class="col-sm-12">
                            <h2 tabindex="0" aria-label="Optional tracking number">Optional tracking number</h2>
                            <input type="text"
                                   formControlName="externalTrackingNumber"
                                   aria-label="Enter optional tracking number"
                                   tabindex="0"
                                   name="externalTrackingNumber"
                                   class="form-control"
                                   maxlength="200"
                                   [readonly]="!canEdit" />
                        </div>
                    </div>

                    <!--------------------------------
                    ORDER DESCRIPTION
                    --------------------------------->
                    <div *ngIf="showOrderDescription" class="row top-space">
                        <div class="row top-space">
                            <div class="col-sm-12">
                                <h2 tabindex="0" aria-label="Description">Description</h2>
                                <input type="text"
                                       formControlName="orderDescription"
                                       name="orderDescription"
                                       aria-label="Enter order description"
                                       tabindex="0"
                                       class="form-control"
                                       maxlength="200"
                                       [readonly]="!canEdit" />
                            </div>
                        </div>
                    </div>

                    <!--------------------------------
                    LABEL LISTING GRID
                    --------------------------------->
                    <div *ngIf="showLlForm" class="row top-space">
                        <div class="row top-space">
                            <div class="col-sm-12 top-space">
                                <h2 tabindex="0" aria-label="Select a data collection form">Select a data collection form</h2>
                                <p tabindex="0" aria-label="Select labeling listing form for this order">Select one Labeling Listing form for this order.</p>
                                <ejs-tooltip #tooltipDC id="tooltipDC" (beforeRender)="tooltipValue($event)"
                                target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                <ejs-grid id='llFormGrid'
                                          #llFormGrid
                                          [dataSource]='llFormGridData'
                                          allowPaging='true'
                                          allowSorting='true'
                                          [pageSettings]='llFormInitialPage'
                                          height="270"
                                          (actionBegin)=begin($event)
                                          [toolbar]='llFormToolbarOptions'
                                          allowScrolling="true"
                                          allowFiltering="true"
                                          [selectionSettings]="llFormGridSelectionOptions"
                                          (rowSelected)='llFormGridRowSelected($event)'
                                          (rowDeselected)='llFormGridRowDeselected($event)'>
                                    <e-columns>
                                        <e-column [customAttributes]="clipmodecolumn" field='formName' headerText='Form Name' clipMode="EllipsisWithTooltip" width='250'>
                                            <ng-template #template let-llFormGridData>
                                                <span class="selectionCheckbox" role="checkbox" aria-checked="false" aria-label="checkbox for LL form"></span>
                                                &nbsp;&nbsp;&nbsp;
                                                <a class='pointer' (click)='viewLLForm(llFormGridData.llRevisionId)' (keydown.enter)="viewLLForm(llFormGridData.llRevisionId)" aria-label="view LL form">
                                                {{llFormGridData.formName}}</a>&nbsp;
                                                <a class='pointer underline' (click)='viewLLForm(llFormGridData.llRevisionId)' (keydown.enter)="viewLLForm(llFormGridData.llRevisionId)" role="link" aria-label="view LL form in new tab">
                                                    <i class="fas fa-external-link-alt" aria-hidden="true" title="This will open in a new tab"></i>
                                                </a>
                                            </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='proprietaryName' headerText='Proprietary Name' width='250'>
                                          <ng-template  #template let-data>
                                            <span>{{toHtml(data.proprietaryName)}}</span>
                                          </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='labelerName' headerText='Labeler Company Name' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='ndcPackageCode' headerText='NDC Package Code' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='businessCategory' headerText='Business Category' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='productType' headerText='Product Type' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='formVersion' headerText='Form Version' clipMode="EllipsisWithTooltip" width='70'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='modifiedBy' headerText='Modified By' clipMode="EllipsisWithTooltip" width='140'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='modifiedDate' headerText='Modified On' type='date' [format]='gridFormatOptions' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                    </e-columns>
                                </ejs-grid>
                                </ejs-tooltip>
                            </div>
                        </div>
                        <div *ngIf="llFormGridSelectedRowData" class="row">
                            <div class="col-sm-12">
                                &nbsp;
                            </div>
                        </div>

                        <!--------------------------------
                        SELECTED FORM SUMMARY
                        --------------------------------->
                        <div *ngIf="llFormGridSelectedRowData" class="row">
                            <div class="col-sm-12">
                                <div class="card selected-ll-form-card">
                                    <div class="card-header bg-light-green">
                                      <div *ngIf='!bIsSelectedLLFormActive'>
                                        <i class="fas fa-exclamation-triangle text-danger" aria-hidden="true"></i>
                                        <b class="alert-text" tabindex="0" aria-label="warning: update form">This form is either not the latest version or no longer exists. Please update.</b>
                                      </div>
                                      <b *ngIf='bIsSelectedLLFormActive' aria-label="Name of form you have selected">You have selected:</b>
                                      <table class="table text-success selected-ll-form-table">
                                            <thead>
                                                <tr>
                                                    <th role="columnheader" aria-label="Form Name" tabindex="0">Form Name</th>
                                                    <th role="columnheader" aria-label="Product or Proprietary Name" tabindex="0">Product/Proprietary Name</th>
                                                    <th role="columnheader" aria-label="Form Version" tabindex="0">Form Version</th>
                                                    <th role="columnheader" aria-label="NDC Package Code" tabindex="0">NDC Package Code</th>
                                                    <th role="columnheader" aria-label="Labeler" tabindex="0">Labeler</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td role="gridcell" aria-label="cell of Form Name" tabindex="0">{{this.llFormGridSelectedRowData.formName}}</td>
                                                    <td role="gridcell" aria-label="cell of Product or Proprietary Name" tabindex="0">{{toHtml(this.llFormGridSelectedRowData.proprietaryName)}}</td>
                                                    <td role="gridcell" aria-label="cell of Form Version" tabindex="0">{{this.llFormGridSelectedRowData.formVersion}}</td>
                                                    <td role="gridcell" aria-label="cell of NDC Package Code" tabindex="0">{{this.llFormGridSelectedRowData.ndcPackageCode}}</td>
                                                    <td role="gridcell" aria-label="cell of Labeler" tabindex="0">{{this.llFormGridSelectedRowData.labelerName}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--------------------------------
                        BASELINE SPL GRID
                        --------------------------------->
                        <div class="row top-space">
                            <div class="col-sm-12">
                                <h2 tabindex="0" aria-label="Select baseline SPL conversion file">Select baseline SPL conversion file</h2>
                                <ejs-tooltip #tooltipSPL id="tooltipSPL" (beforeRender)="tooltipValue($event)"
                                target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                <ejs-grid id='baselineSplGrid'
                                          #baselineSplGrid
                                          [dataSource]='baselineSplGridData'
                                          [selectionSettings]='baselineSplSelectionOptions'
                                          allowPaging='true'
                                          allowSorting='true'
                                          [pageSettings]='baselineSplInitialPage'
                                          height="270"
                                          (actionBegin)=begin($event)
                                          [toolbar]='llFormToolbarOptions'
                                          allowScrolling="true"
                                          allowFiltering="true"
                                          (rowSelected)='baselineSplGridRowSelected($event)'
                                          (rowDeselected)='baselineSplGridRowDeselected($event)'>
                                    <e-columns>
                                        <e-column [customAttributes]="clipmodecolumn" field='orderId' headerText='Order ID' clipMode="EllipsisWithTooltip" width='100'>
                                            <ng-template #template let-baselineSplGridData>
                                                <span class="selectionCheckbox" role="checkbox" aria-checked="false" aria-label="checkbox"></span>
                                                &nbsp;&nbsp;&nbsp;
                                                {{baselineSplGridData.workflowOrderId}}
                                            </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='fileName' headerText='File Name' width='190'>
                                            <ng-template #template let-baselineSplGridData>
                                                <a class='pointer underline' (click)='downloadFile(baselineSplGridData.filePath, baselineSplGridData.fileName)'
                                                    (keydown.enter)="downloadFile(baselineSplGridData.filePath, baselineSplGridData.fileName)" aria-label="download file">
                                                    <i class="fas fa-download"
                                                                title="Download the file"></i>&nbsp;
                                                    {{baselineSplGridData.fileName}}
                                                </a>
                                            </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='externalTrackingNumber' headerText='Tracking Number' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='ndcPackageCodes' headerText='NDC Package Code' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='actualDeliveryDate' headerText='Delivered Date/Time' type='date' [format]='gridFormatOptions' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                    </e-columns>
                                </ejs-grid>
                                </ejs-tooltip>
                            </div>
                        </div>
                    </div>

                    <!--------------------------------
                    EXISTING FILES
                    --------------------------------->
                    <div class="row top-space">
                        <div class="col-sm-12">
                            <h2 class="mb-3" tabindex="0" aria-label="Source Documentation">Source Documentation</h2>
                            <h3 class="mb-3" tabindex="0" aria-label="Current Documents">Current Documents</h3>
                            <table class="table table-inner table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th role="columnheader" aria-label="File name" tabindex="0">File name</th>
                                        <th role="columnheader" aria-label="Size" tabindex="0">Size</th>
                                        <th role="columnheader" aria-label="Uploaded by" tabindex="0">Uploaded by</th>
                                        <th role="columnheader" aria-label="Uploaded date" tabindex="0">Uploaded date</th>
                                        <th *ngIf="canEdit" role="columnheader" aria-label="Action" tabindex="0">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="!sourceDocs || sourceDocs.length == 0">
                                        <td role="gridcell" aria-label="No records found" tabindex="0"><i>No records found</i></td>
                                        <td role="gridcell" aria-label="No records found" tabindex="0"></td>
                                        <td role="gridcell" aria-label="No records found" tabindex="0"></td>
                                        <td role="gridcell" aria-label="No records found" tabindex="0"></td>
                                        <td *ngIf="canEdit" role="gridcell" aria-label="No records found" tabindex="0"></td>
                                    </tr>
                                    <tr *ngFor="let myDoc of sourceDocs">
                                        <td role="gridcell" aria-label="cell of File name" tabindex="0"><a class="pointer" (click)='downloadFile(myDoc.filePath, myDoc.title)'
                                          aria-label="download file" (keydown.enter)="downloadFile(myDoc.filePath, myDoc.title)">
                                          <i class="fas fa-download"title="Download the file"></i>&nbsp;{{myDoc.title}}</a>
                                        </td>
                                        <td align="right" role="gridcell" aria-label="cell of Size" tabindex="0">{{myDoc.size | number:'1.0':'en-US'}}</td>
                                        <td role="gridcell" aria-label="cell of Uploaded by" tabindex="0">{{myDoc.uploadedBy}}</td>
                                        <td role="gridcell" aria-label="cell of Uploaded date" tabindex="0">{{myDoc.uploadedDate | date:'M/d/yyyy h:mm:ss a'}}</td>
                                        <td *ngIf="canEdit" role="gridcell" aria-label="cell of Action" tabindex="0">
                                            <div *ngIf="!myDoc.isDeleted">
                                                <a (click)="deleteExistingFile(myDoc.index)" onmouseover="this.style.cursor='pointer'" aria-label="delete existiing file"
                                                (keydown.enter)="deleteExistingFile(myDoc.index)">
                                                    <span class="fas fa-trash-alt" aria-hidden="true"></span>&nbsp;Delete
                                                </a>
                                            </div>
                                            <div *ngIf="myDoc.isDeleted">
                                                <a (click)="undeleteExistingFile(myDoc.index)" onmouseover="this.style.cursor='pointer'" aria-label="undelete existiing file"
                                                (keydown.enter)="undeleteExistingFile(myDoc.index)">
                                                    <span class="fas fa-trash-alt text-danger" aria-hidden="true"></span>&nbsp;<span class="text-danger">Will be deleted</span>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!--------------------------------
                    FILE UPLOAD
                    --------------------------------->
                    <div *ngIf="canEdit" class="row top-space">
                        <div class="col-sm-12">
                            <h3 tabindex="0" aria-label="New documents">New Documents</h3>
                            <p tabindex="0" aria-label="upload new source documentation">
                                To upload new source documentation,
                                <a class="pointer" (click)="browseClick()" aria-label="browse" (keydown.enter)="browseClick()">
                                    browse <span class="glyphicon glyphicon-folder-open"></span>
                                </a>&nbsp;
                                for files or drag and drop below.
                            </p>

                            <div id='dropArea' class="dashed">
                                Drop files here
                            </div>
                            <p>&nbsp;</p>

                            <div id="droppingArea">
                                <ejs-uploader #fileUpload
                                              id='fileUpload'
                                              [dropArea]='dropElement'
                                              [autoUpload]='false'
                                              (created)='onCreated()'
                                              (removing)="onRemove($event)"
                                              [asyncSettings]='fileUploadAsyncSettings'
                                              (selected)='onSelected($event);'
                                              (uploading)='onUploading($event); addCorsHeaders($event);'
                                              (success)='onSuccess($event)'
                                              (actionComplete)='onActionComplete($event)'
                                              (failure)='onUploadFailure($event)'
                                              [allowedExtensions]='validFileExtensionsStr'
                                              [minFileSize]='fileMinSize'
                                              [maxFileSize]='fileMaxSize'>
                                </ejs-uploader>

                            </div>
                        </div>
                    </div>

                    <!--------------------------------
                    BUTTONS
                    --------------------------------->
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <a class="btn btn-default" routerLink="/order-tracker" aria-label="Back to list">
                                <i class="fas fa-angle-left" aria-hidden="true"></i>
                                Back to list
                            </a>
                            <button class="btn btn-primary float-end mx-1" role="button" aria-label="Next Step"
                                    (click)="validateDataCollectionSelection()"
                                    (keydown.enter)="validateDataCollectionSelection()"
                                    id="btnNext"
                                    [disabled]="!orderStep2Form.valid || (pageState !== orderService.PAGE_STATE_READY)">
                                Next Step
                                <i class="fas fa-angle-double-right" aria-hidden="true"></i>
                            </button>
                            <button class="btn btn-info float-end mx-1" role="button" aria-label="Save button"
                                    (click)="saveData('STEP2');"
                                    (keydown.enter)="saveData('STEP2');"
                                    [disabled]="!orderStep2Form.valid || (pageState !== orderService.PAGE_STATE_READY) || !(canEdit || orderAdmin)">
                                {{saveButtonCaption}}
                            </button>
                            <button class="btn btn-primary float-end mx-1" role="button" aria-label="Previous Step"
                                    (click)="saveData('STEP1')"
                                    (keydown.enter)="saveData('STEP1')"
                                    id="btnPrevious"
                                    [disabled]="!orderStep2Form.valid || (pageState !== orderService.PAGE_STATE_READY)">
                                <i class="fas fa-angle-double-left" aria-hidden="true"></i>
                                Previous Step
                            </button>
                            <button class="btn btn-info float-end mx-1" role="button" aria-label="Request Order Cancellation"
                                    (click)="saveData('CANCEL');"
                                    (keydown.enter)="saveData('CANCEL');"
                                    *ngIf="canRequestCancellation">
                                Request Order Cancellation
                            </button>
                        </div>
                    </div>

                    <!--------------------------------
                    ERROR MESSAGE
                    --------------------------------->
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <div *ngIf="errorMessage!=null && errorMessage!=''" class="alert-text left-padding alert">{{errorMessage}}</div>
                        </div>
                    </div>

                </div>

                <!--------------------------------
                RIGHT PANEL
                --------------------------------->
                <div class="col-sm-3">
                    <!--------------------------------
                    ORDER SUMMARY
                    --------------------------------->
                    <order-summary whichStep="STEP2"
                                   [order]="order"
                                   [allEmployeesInCompany]="allEmployeesInCompany"
                                   [serviceCategories]="serviceCategories">
                    </order-summary>

                    <p>&nbsp;</p>

                    <!--------------------------------
                    ORDER ADMIN
                    --------------------------------->
                    <order-admin #orderAdminComponent
                                 *ngIf="canOrderAdmin"
                                 [orderStatuses]="orderStatuses"
                                 [order]="order"
                                 [canEdit]="canEdit"
                                 [postSaveDataNewOrderRevisionId]="postSaveDataNewOrderRevisionId"
                                 [deliveryDoc]="deliveryDoc"
                                 (onOrderAdminFileUpload)="onOrderAdminFileUpload($event)"
                                 (onIngestFilechanged)="onIngestFilechanged($event)">
                    </order-admin>
                </div>
            </div>
        </form>

        <!--------------------------------
        PROGRESS SPINNER
        --------------------------------->
        <div *ngIf="pageState !== this.orderService.PAGE_STATE_READY">
            <div id="loading"></div>
        </div>
    </div>
</div>

<ejs-dialog #confirmDialog [isModal]='true' [buttons]='confirmDlgButtons' [visible]='false'
    [position]='position' [animationSettings]='animationSettings' [width]='450'>
    <ng-template #content>
      <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0" aria-label="Data Collection Form Selection">Data Collection Form Selection</h3>
        </div>
        <div class="card-body" tabindex="0" aria-label="information">
            A data collection form has not been selected for this order.  Without a data collection form you will not be able to select this order as a candidate for a Merge.
        </div>
      </div>
    </ng-template>
</ejs-dialog>
</main>



